import { render } from "./GlobalLoader.vue?vue&type=template&id=65225fb9&scoped=true"
const script = {}

import "./GlobalLoader.vue?vue&type=style&index=0&id=65225fb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65225fb9"]])

export default __exports__